import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import * as style from "./style.module.css";
import Map from "/src/components/Map";
import PageTop from "/src/components/PageTop";
import json from "/src/siteData.json";
import logo from "/src/images/top/logo.png";
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType";

const data = json.footer;
const logoUri = json.header.logoUri;
const siteMetaData = json.siteMetadata;

const Component = () => {
  return (
    <>
      {/* <PageTop showBelow={900} /> */}
      <footer className={style.footer}>
        <div className={"content"}>
          <div className={`flex_sb ${style.footerTop}`}>
            <div className={style.map}>
              <Map address={data.address} />
            </div>
            <div className={style.footerLeft}>
              <Link to="/" className={style.footer_logo}>
                <img
                  src={logo}
                  alt={siteMetaData.title}
                  style={{ objectFit: "contain" }}
                />
              </Link>
              <p>
                中学受験塾Act
                <br />
                Tel：045-870-1612（戸塚校）
                <br />
                営業時間：13：30〜21：00
                <br />
                〒244-0002 神奈川県横浜市戸塚区矢部町19
              </p>
            </div>
            <div className={style.footerRight}>
              <ul className={style.list}>
                <li className={style.nav_item}>
                  <Link to="/">ホーム</Link>
                </li>
                <li className={style.nav_item}>
                  <Link to={getPathFromTemplateType(4)}>お知らせ</Link>
                </li>
                <li className={style.nav_item}>
                  <Link to="/omoi">理念</Link>
                </li>
                <li className={style.nav_item}>
                  <Link to="/about">中学受験について</Link>
                </li>
                <li className={style.nav_item}>
                  <Link to="/flow">入塾までの流れと受講料</Link>
                </li>
                <li className={style.nav_item}>
                  <Link to="/passed">合格実績</Link>
                </li>
                <li className={style.nav_item}>
                  <Link to="/faq">よくある質問</Link>
                </li>
                <li className={style.nav_item}>
                  <Link to="/recruit/office_part/">採用情報</Link>
                </li>
                <li className={style.nav_item}>
                  <Link to={getPathFromTemplateType(6)}>お問い合わせ</Link>
                </li>
                <li className={style.nav_item}>
                  <Link to={getPathFromTemplateType(5)}>
                    プライバシーポリシー
                  </Link>
                </li>
                {/* <li className={style.nav_item}>
                  <Link to="/class">学年別クラス</Link>
                </li> */}
              </ul>
            </div>
          </div>

          <div className={`flex_sb ${style.footerBottom}`}>
            <ul className={style.sns_list}>
              {data.facebookUrl && (
                <li>
                  <Link to={data.facebookUrl}>
                    <StaticImage
                      src="../../images/icon/sns-facebook-wh.svg"
                      placeholder="none"
                      loading="eager"
                      formats={["auto", "webp", "avif"]}
                      alt="Facebook"
                    />
                  </Link>
                </li>
              )}
              {data.instagramUrl && (
                <li>
                  <Link to={data.instagramUrl}>
                    <StaticImage
                      src="../../images/icon/sns-instagram-wh.svg"
                      placeholder="none"
                      loading="eager"
                      formats={["auto", "webp", "avif"]}
                      alt="Instagram"
                    />
                  </Link>
                </li>
              )}
              {data.lineUrl && (
                <li>
                  <Link to={data.lineUrl}>
                    <StaticImage
                      src="../../images/icon/sns-line-wh.svg"
                      placeholder="none"
                      loading="eager"
                      formats={["auto", "webp", "avif"]}
                      alt="LINE"
                    />
                  </Link>
                </li>
              )}
              {data.xUrl && (
                <li>
                  <Link to={data.xUrl}>
                    <StaticImage
                      src="../../images/icon/sns-x-wh.svg"
                      placeholder="none"
                      loading="eager"
                      formats={["auto", "webp", "avif"]}
                      alt="X"
                    />
                  </Link>
                </li>
              )}
            </ul>
            <small className={style.copyright}>&copy; {data.copyright}</small>
          </div>
          {/* <div>
            <Link
              className={style.privacy_policy_link}
              to={getPathFromTemplateType(5)}
            >
              プライバシーポリシー
            </Link>            
          </div> */}
        </div>
      </footer>
    </>
  );
};

export default Component;
